export const route = {
  dashboard: 'Main panel',
  statistics: 'Statistics',
  configuration: 'Configuration templates',
  flows: 'Configuration templates',
  files: 'Files',
  new: 'New configuration template',
  roles: 'Roles',
  users: 'Users',
  configurationFinished: 'Finished configuration templates',
  profile: 'Profile',
  packages: 'Packages',
  createConfiguration: 'Creating configuration template',
  login: 'Login',
  editor: 'Editor',
  landingPage: 'Home',
  pathway: 'Configurator',
  resetPassword: 'Reset password',
  verifyEmail: 'Verify email',
  blockly: 'Rules editor',
  configurationsFinished: 'Finished configuration',
  configurationsSummary: 'Configuration summary',
  configurationsSummaryAr: 'Configuration summary in AR',
  pathwayAr: 'Configurator in AR',
  logs: 'Logs',
  criteria: 'Criteria',
}
